import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import './bgimg.css';
import BackgroundImage from 'gatsby-background-image-es5';

export const DiverBackground: React.FC<{
  className: any,
}> = ({ className }) => {
  const {
    diver,
    diverWide
  } = useStaticQuery(
    graphql`
      query {
        diver: file(
          relativePath: { eq: "diver768.jpg" }
          ) {
          childImageSharp {
            fluid(
              quality: 90,
              maxWidth: 768,
              srcSetBreakpoints: [ 414, 768 ]
            ) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        },
        diverWide: file(
          relativePath: { eq: "diver1920.jpg" }
          ) {
          childImageSharp {
            fluid(
              quality: 90,
              maxWidth: 1920,
              srcSetBreakpoints: [768, 1024, 1440, 1920]
            ) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const backgroundFluidImageStack = [
    diver.childImageSharp.fluid,
    {
      ...diverWide.childImageSharp.fluid,
      media: '(min-width: 769px)',
    },
  ];

  return (
    <BackgroundImage
      Tag={'section'}
      className={className}
      fluid={backgroundFluidImageStack}
      style={{
        // Defaults are overwrite-able by setting one or each of the following:
        position: 'absolute',
        backgroundPosition: 'center bottom',
        opacity: '1',
      }}
    >
    </BackgroundImage>
  );
};
